<template>
  <div class="info prelative cpointer pt20 pb20" @click="goRoute(item.id)">
    <span class="pabsolute smg"></span>
    <div class="txt">
      <div class="nm fs16 ofhidden lh10 mb10">
        {{item.title}}
      </div>
      <div class="fs12 tc9">
        <span class="mr30">{{item.views_count}}人下载</span>
        <span>审核时间：{{item.release_time}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zk-item",
  props: [
    'item',
  ],
  methods:{
    goRoute(id){
      this.$router.push({path:'/cedu/data/detail',query:{id:id}})
    },
  }
}
</script>

<style scoped>
  .zindex-wrap .info{width: 735px;}
  .info:hover{background-color: #fcfcfc;color: #3a8c39;font-weight: bold;}
  .info:hover .tc9{color: #3a8c39;}
  .info{padding-left: 65px;border-bottom: 1px solid #eee;}
  .info .nm{height: 16px;}
  .info .smg{left: 0;width: 65px;height: 50px;background: url(../../assets/images/cn1.png) no-repeat -200px -15px;}
</style>



// WEBPACK FOOTER //
// src/components/hedu/zk-item.vue